export default {
    setSelectedCustomer(state, customer) {
        state.selectedCustomer = customer;
    },
};
